import fastapiAxios from "../../api/fastapiAxios";

class ChatAPI {
  createChat(payload) {
    return fastapiAxios.post('/new', payload);
  }

  streamChat(payload) {
    return fastapiAxios.post('/stream', payload);
  }

  getChatHistory(params) {
    return fastapiAxios.get('/history', { params });
  }

  getChatSessions(params) {
    return fastapiAxios.get('/sessions', { params });
  }

  clearChat(params) {
    return fastapiAxios.delete('/clear', { params });
  }
}

const chatApi = new ChatAPI();
export default chatApi;

